<template>
  <div class="pos-order-details fill-height d-flex flex-column bg-white rounded-lg elevation-1 ma-2">
    <!-- Header -->
    <div class="d-flex align-center justify-space-between pa-4 border-bottom">
      <div class="d-flex align-center">
        <h2 class="text-h6 font-weight-bold grey--text text--darken-3 mr-2">
          DETALHES DO PEDIDO
        </h2>
        <v-chip color="success" x-small class="font-weight-bold">
          Itens: {{ items.length }}
        </v-chip>
      </div>
      <v-btn
        text
        color="error"
        small
        class="text-capitalize font-weight-bold px-2"
        @click="$emit('clear-all')"
        :disabled="items.length === 0"
      >
        Limpar Tudo <v-icon right x-small>{{ icons.mdiClose }}</v-icon>
      </v-btn>
    </div>

    <!-- Table Header (Custom for better control than v-data-table headers) -->
    <div class="d-flex pa-3 grey lighten-4 text-caption font-weight-bold grey--text text--darken-1">
      <div class="flex-grow-1 pl-2">Produto</div>
      <div class="text-center" style="width: 100px">Preço</div>
      <div class="text-center" style="width: 120px">Qtd</div>
      <div class="text-right" style="width: 100px">Subtotal</div>
      <div class="text-center" style="width: 50px">Ação</div>
    </div>

    <!-- List -->
    <div class="flex-grow-1 overflow-y-auto custom-scrollbar">
       <div v-if="items.length === 0" class="d-flex flex-column align-center justify-center fill-height opacity-50 py-12">
          <v-icon size="64" color="grey lighten-2">{{ icons.mdiBasketOutline }}</v-icon>
          <span class="text-body-2 grey--text mt-2">Nenhum item adicionado</span>
       </div>

       <div
         v-for="(item, index) in items"
         :key="item.id"
         class="d-flex align-center pa-3 border-bottom hover-row"
       >
         <!-- Product Info -->
         <div class="flex-grow-1 d-flex align-center overflow-hidden">
            <div 
              v-if="item.image"
              class="rounded mr-3 d-flex align-center justify-center grey lighten-3 overflow-hidden"
              style="width: 48px; height: 48px; flex-shrink: 0;"
            >
              <v-img :src="item.image" contain width="100%" height="100%"></v-img>
            </div>
            <div 
              v-else
              class="rounded mr-3 d-flex align-center justify-center grey lighten-3"
              style="width: 48px; height: 48px; flex-shrink: 0;"
            >
              <v-icon color="grey darken-1">{{ icons.mdiPackageVariant }}</v-icon>
            </div>
            <div class="overflow-hidden">
               <div class="font-weight-bold text-body-2 text-truncate">{{ item.name }}</div>
               <div class="caption grey--text">SKU: {{ item.sku || '---' }}</div>
               <!-- Optional: Show stock if available -->
               <div class="caption grey--text" v-if="item.stock">Estoque: {{ item.stock }}</div>
            </div>
         </div>

         <!-- Price -->
         <div class="text-center font-weight-medium text-body-2" style="width: 100px">
           {{ (item.price / 100) | moneyBr }}
         </div>

         <!-- Quantity -->
         <div class="d-flex align-center justify-center" style="width: 120px">
            <v-btn icon x-small class="grey lighten-3 ma-1" @click="$emit('update-qty', { item, qty: item.qty - 1 })">
              <v-icon x-small>{{ icons.mdiMinus }}</v-icon>
            </v-btn>
            <span class="font-weight-bold mx-2">{{ item.qty }}</span>
            <v-btn icon x-small class="grey lighten-3 ma-1" @click="$emit('update-qty', { item, qty: item.qty + 1 })">
              <v-icon x-small>{{ icons.mdiPlus }}</v-icon>
            </v-btn>
         </div>

         <!-- Subtotal -->
         <div class="text-right font-weight-bold text-body-2" style="width: 100px">
            {{ ((item.price * item.qty) / 100) | moneyBr }}
         </div>

         <!-- Action -->
         <div class="text-center" style="width: 50px">
            <v-btn icon small color="grey" @click="$emit('remove', item)">
               <v-icon small>{{ icons.mdiDeleteOutline }}</v-icon>
            </v-btn>
         </div>
       </div>
    </div>
    
  </div>
</template>

<script>
import { 
  mdiClose, 
  mdiBasketOutline, 
  mdiImageOffOutline, 
  mdiMinus, 
  mdiPlus, 
  mdiDeleteOutline 
} from '@mdi/js';

export default {
  name: "POSOrderDetails",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      icons: {
        mdiClose,
        mdiBasketOutline,
        mdiImageOffOutline,
        mdiMinus,
        mdiPlus,
        mdiDeleteOutline
      }
    };
  }
};
</script>

<style scoped>
.pos-order-details {
  border: 1px solid #e0e0e0;
}
.border-bottom {
  border-bottom: 1px solid #f0f0f0;
}
.hover-row:hover {
  background-color: #fafafa;
}
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #e0e0e0;
  border-radius: 4px;
}
</style>
